module.exports = __webpack_public_path__ + "static/media/research_3.6f64cb48.png";